export default [
  {
    name: 'lobby-banners',
    path: '/lobby-banners',
    component: () => import(/* webpackChunkName: "event" */ './Index.vue'),
    meta: {
      showNavbar: true,
      title: 'Lobby Banners',
      icon: 'dvr',
      label: 'Lobby Banners'
    }
  }
]
